const updateMembersWorkoutsSearchTerm = (state, { payload }) => {
	state.membersWorkoutsSearchTerm = payload;
};

export default updateMembersWorkoutsSearchTerm;
